(function () {
  if (window.solarCoverShapeSwitcherReady) return;
  window.solarCoverShapeSwitcherReady = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-solar-shape-control]');
    if (!button) return;

    var builder = button.closest('#SolarCoverBuilder');
    if (!builder) return;

    var selectedShape = button.dataset.solarShapeControl;
    var isCurrentVariantShape = selectedShape === builder.dataset.solarSelectedShape;

    builder.querySelectorAll('[data-solar-shape-control]').forEach(function (shapeButton) {
      var isSelected = shapeButton === button;
      shapeButton.classList.toggle('is-active', isSelected);
      shapeButton.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    builder.querySelectorAll('[data-solar-shape-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.solarShapePanel !== selectedShape;
    });

    var currentShape = builder.querySelector('[data-solar-shape-current]');
    if (currentShape) currentShape.textContent = button.dataset.solarShapeLabel;

    var currentSize = builder.querySelector('[data-solar-size-current]');
    if (currentSize) {
      currentSize.textContent = isCurrentVariantShape
        ? builder.dataset.solarSelectedSize
        : builder.dataset.solarSizePrompt;
    }

    var submitButton = builder.querySelector('.js-variant-picker__form-submit');
    if (submitButton) submitButton.disabled = !isCurrentVariantShape;
  });

  function setupSolarStickyCart() {
    var builder = document.querySelector('#SolarCoverBuilder');
    var template = document.querySelector('[data-solar-sticky-cart-template]');
    if (!builder || !template || !document.body) return;

    var railSubmit = builder.querySelector('.js-variant-picker__form-submit');
    var contentRoot = builder.closest('.js-main-product__content') || builder;
    if (!railSubmit) return;

    var existing = document.querySelector('.smcbx__atc-bar--solar');
    if (existing && typeof existing._smcbxCleanup === 'function') existing._smcbxCleanup();
    if (existing) existing.remove();

    var bar = template.content.firstElementChild.cloneNode(true);
    var price = bar.querySelector('.smcbx__atc-price');
    var thumb = bar.querySelector('.smcbx__atc-thumb');
    var button = bar.querySelector('.smcbx__atc-button');
    var buttonText = bar.querySelector('.smcbx__atc-button-text');
    var reviewSub = bar.querySelector('.smcbx__atc-sub');
    var reviewText = bar.querySelector('.smcbx__atc-reviewtext');
    var syncFrame = 0;
    var lateSync = 0;
    var observer = null;
    var reviewTries = 0;

    document.body.appendChild(bar);
    document.body.classList.add('smcbx-has-sticky-atc');
    button.type = 'button';

    function hiddenInput(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      return input;
    }

    function submitStickyCart() {
      if (!button || button.disabled) return;

      var currentBuilder = document.querySelector('#SolarCoverBuilder');
      var currentSubmit = currentBuilder && currentBuilder.querySelector('.js-variant-picker__form-submit');
      var currentForm = currentSubmit && currentSubmit.closest('form');
      var variantInput = currentForm && currentForm.querySelector('input[name="id"]');
      var quantityInput = currentForm && currentForm.querySelector('input[name="quantity"]');
      if (!currentForm || !variantInput || !variantInput.value) return;

      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');

      var cartForm = document.createElement('form');
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      cartForm.method = 'post';
      cartForm.action = currentForm.getAttribute('action') || (root + 'cart/add');
      cartForm.hidden = true;
      cartForm.appendChild(hiddenInput('id', variantInput.value));
      cartForm.appendChild(hiddenInput('quantity', quantityInput && quantityInput.value ? quantityInput.value : '1'));
      cartForm.appendChild(hiddenInput('return_to', root + 'cart'));
      document.body.appendChild(cartForm);
      cartForm.submit();
    }

    button.addEventListener('click', submitStickyCart);

    function readProductRating() {
      var widget = document.querySelector('.loox-rating[data-rating]') || document.querySelector('.loox-rating');
      if (!widget) return null;
      var rating = (widget.getAttribute('data-rating') || '').trim();
      var count = (widget.getAttribute('data-raters') || widget.getAttribute('data-count') || '').trim();
      var text = (widget.textContent || '').replace(/\s+/g, ' ').trim();
      if (!rating) {
        var ratingMatch = text.match(/[0-9]+(?:\.[0-9]+)?/);
        if (ratingMatch) rating = ratingMatch[0];
      }
      if (!count) {
        var countMatch = text.match(/\(([\d,]+)\s*review/i);
        if (countMatch) count = countMatch[1].replace(/,/g, '');
      }
      if (!rating || parseFloat(rating) <= 0) return null;
      return { rating: rating, count: count };
    }

    function syncReviews() {
      var review = readProductRating();
      if (!review) {
        if (reviewTries++ < 16) window.setTimeout(syncReviews, 500);
        return;
      }
      var isFrench = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
      var rating = isFrench ? review.rating.replace('.', ',') : review.rating;
      var count = parseInt((review.count || '').replace(/[^0-9]/g, ''), 10);
      var label = rating;
      if (count) label += ' \u00b7 ' + review.count + ' ' + (isFrench ? 'avis' : count === 1 ? 'review' : 'reviews');
      reviewText.textContent = label;
      reviewSub.hidden = false;
    }

    function syncBottomOffset() {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var nodes = document.querySelectorAll("#preview-bar-iframe, #admin-bar-iframe, iframe[src*='preview_bar'], iframe[src*='preview-bar']");
      var offset = 0;
      Array.prototype.forEach.call(nodes, function (node) {
        var style = window.getComputedStyle ? window.getComputedStyle(node) : null;
        if (style && (style.display === 'none' || style.visibility === 'hidden')) return;
        var rect = node.getBoundingClientRect();
        if (rect.height < 1 || rect.height > viewportHeight * 0.4) return;
        if (Math.abs(viewportHeight - rect.bottom) > 16) return;
        if (rect.height > offset) offset = Math.ceil(rect.height);
      });
      document.documentElement.style.setProperty('--smcbx-sticky-atc-bottom', offset + 'px');
    }

    function syncBar() {
      var currentBuilder = document.querySelector('#SolarCoverBuilder');
      if (!currentBuilder) return;
      var summary = currentBuilder.querySelector('.c-variant-picker__order-summary');
      var summaryPrice = summary && summary.querySelector('b');
      var summaryThumb = summary && summary.querySelector('img');
      var currentSubmit = currentBuilder.querySelector('.js-variant-picker__form-submit');
      var currentForm = currentSubmit && currentSubmit.closest('form');

      if (summaryPrice && price) price.textContent = summaryPrice.textContent;
      if (summaryThumb && thumb) {
        thumb.src = summaryThumb.currentSrc || summaryThumb.src;
        thumb.srcset = summaryThumb.srcset || '';
      }
      if (currentSubmit && button && buttonText) {
        buttonText.textContent = String(currentSubmit.textContent || '').trim();
        button.disabled = currentSubmit.disabled;
        if (currentSubmit.disabled) button.setAttribute('aria-disabled', 'true');
        else button.removeAttribute('aria-disabled');
      }

      syncBottomOffset();
      document.documentElement.style.setProperty('--smcbx-sticky-atc-height', Math.ceil(bar.getBoundingClientRect().height || 0) + 'px');
    }

    function queueSync() {
      if (syncFrame) return;
      syncFrame = window.requestAnimationFrame(function () {
        syncFrame = 0;
        syncBar();
      });
    }

    window.addEventListener('resize', queueSync);

    if (window.MutationObserver) {
      observer = new window.MutationObserver(queueSync);
      observer.observe(contentRoot, { attributes: true, childList: true, characterData: true, subtree: true });
    }

    bar._smcbxCleanup = function () {
      if (observer) observer.disconnect();
      if (syncFrame) window.cancelAnimationFrame(syncFrame);
      if (lateSync) window.clearTimeout(lateSync);
      button.removeEventListener('click', submitStickyCart);
      window.removeEventListener('resize', queueSync);
      if (document.querySelector('.smcbx__atc-bar--solar') === bar) {
        document.body.classList.remove('smcbx-has-sticky-atc');
        document.documentElement.style.removeProperty('--smcbx-sticky-atc-height');
        document.documentElement.style.removeProperty('--smcbx-sticky-atc-bottom');
      }
    };

    syncReviews();
    syncBar();
    lateSync = window.setTimeout(syncBar, 1500);
  }

  function tuneSolarGallery() {
    var gallery = document.querySelector(
      'body.template-product-solar-cover .s-main-product--solar-cover c-product-media'
    );
    if (!gallery || !gallery.mainSwiper) return;

    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    gallery.mainSwiper.params.slidesPerView = 1;
    gallery.mainSwiper.params.spaceBetween = isMobile ? 0 : 0;
    gallery.mainSwiper.update();

    if (gallery.thumbsSwiper) {
      gallery.thumbsSwiper.changeDirection(isMobile ? 'horizontal' : 'vertical');
      gallery.thumbsSwiper.params.slidesPerView = 'auto';
      gallery.thumbsSwiper.update();
    }
  }

  customElements.whenDefined('c-product-media').then(function () {
    window.requestAnimationFrame(tuneSolarGallery);
  });

  setupSolarStickyCart();
  window.addEventListener('resize', tuneSolarGallery);
  document.addEventListener('shopify:section:load', function () {
    tuneSolarGallery();
    setupSolarStickyCart();
  });
})();
